import React, { useState } from 'react'
import {
    Container,
    Content,
    Form,
    Alert,
    Button
} from './styles';
import { useAuth } from '../../contexts/AuthContexts';
import { Link, useNavigate } from 'react-router-dom';

export const Login = () => {

    const [registerEmail, setRegisterEmail] = useState("")
    const [registerPassword, setRegisterPassword] = useState("")
    const { login } = useAuth();
    const [ error, setError ] = useState("");
    const [ loading, setLoading ] = useState(false);
    const history = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setError("");
            setLoading(true);
            await login(registerEmail, registerPassword);
            history("/profile");
        } catch {
            setError("Failed to Sign In");
        }

        setLoading(false);
    }
    return (
        <Container>
            <Content>
                <Form>
                    <h1> Bem Vindo </h1>
                    { error && <Alert>{error}</Alert>}
                        <input
                            className="input" 
                            placeholder="Email"
                            onChange = {(event) => {
                                setRegisterEmail(event.target.value)
                            }}
                        />
                        <input 
                            className="input" 
                            placeholder="Senha"
                            type="password"
                            onChange = {(event) => {
                                setRegisterPassword(event.target.value)
                            }}
                        />
                        <div>
                            <Link to="/forgot-password">Esqueceu a senha?</Link>
                        </div>
                        <Button disabled={ loading } onClick={ handleSubmit }> Entrar </Button>
                </Form>
                <div>
                    Precisa de uma conta? <Link to="/signup">Cadastrar</Link>
                </div>
            </Content>
        </Container>
    )
}